import CoachInfo from './CoachInfo';

export default CoachInfo;
